import { createAction } from 'modules/redux-store';

export const blogActions = {
  setCategory: (category: BlogCategory) =>
    createAction('blog/SET_CATEGORY', { category }),
};
